import { Component, OnInit } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ChildUsersService } from './child-users.service';
import { ChildUser } from './child-user-model';
import { ChildUserPermissions } from './child-user.permissions.model';
import { consts } from '../../../consts';

const INGRESOS_KEYS = [
  'resumen',
  'ingresosPresupuestos', 'ingresosAlbaranes', 'ingresosFacturas',
  'ingresosRecurrentes', 'ingresosSubvenciones', 'ingresosTickets',
  'ingresosAnticipos', 'ingresosFinancieros', 'ingresosIrpfCuenta',
  'ingresosEstadisticas', 'ingresosOrdenesTrabajo',
];

@Component({
    selector: 'child-users',
    templateUrl: './child-users.component.html',
    styleUrls: ['./child-users.component.css'],
    providers: [ChildUsersService],
    standalone: false
})
export class ChildUsersComponent implements OnInit {
    users: ChildUser[] = [];
    newUser: ChildUser = new ChildUser();
    selectedUser: ChildUser | null = null;
    permissions: ChildUserPermissions = new ChildUserPermissions();
    permissionLabels: { [key: string]: string } = consts.permissionLabels;
    permissionKeys: string[] = [];

    // Permissions split into categories
    ingresoKeys: string[] = [];
    otherKeys: string[] = [];

    // UI state
    showCreate = false;
    showPasswordForm = false;
    showPwChange = false;
    newPassword = '';
    deletePending: ChildUser | null = null;

    constructor(
        private service: ChildUsersService,
        private snackBar: MatSnackBar,
    ) { }

    ngOnInit() {
        this.loadUsers();
    }

    loadUsers() {
        this.service.getAll().then(data => {
            this.users = data;
        });
    }

    createUser() {
        this.service.create(this.newUser).then(() => {
            this.notify('Usuario creado correctamente');
            this.newUser = new ChildUser();
            this.loadUsers();
        }).catch(() => {
            this.notify('El correo electrónico ya se encuentra en uso', true);
        });
    }

    editPermissions(user: ChildUser) {
        this.selectedUser = user;
        this.deletePending = null;
        this.showPasswordForm = false;
        this.newPassword = '';
        this.service.getPermissions(user.id).then(data => {
            this.permissions = data;
            this.permissionKeys = Object.keys(data)
                .filter(key => typeof data[key] === 'boolean' && key in this.permissionLabels);
            this.ingresoKeys = this.permissionKeys.filter(k => INGRESOS_KEYS.includes(k));
            this.otherKeys   = this.permissionKeys.filter(k => !INGRESOS_KEYS.includes(k));
        });
    }

    savePermissions() {
        if (!this.selectedUser) return;
        this.service.updatePermissions(this.selectedUser.id, this.permissions).then(() => {
            this.notify('Permisos actualizados correctamente');
        });
    }

    confirmDelete() {
        if (!this.deletePending) return;
        const user = this.deletePending;
        this.deletePending = null;
        this.service.delete(user.id).then(() => {
            this.notify(`Usuario ${user.name} eliminado`);
            this.selectedUser = null;
            this.loadUsers();
        });
    }

    changePassword() {
        if (!this.selectedUser || !this.newPassword) return;
        this.service.changePassword(this.selectedUser.id, this.newPassword).then(() => {
            this.notify('Contraseña actualizada correctamente');
            this.cancelPasswordChange();
        });
    }

    cancelPasswordChange() {
        this.showPasswordForm = false;
        this.showPwChange = false;
        this.newPassword = '';
    }

    getInitials(name: string): string {
        if (!name) return '?';
        return name.trim().split(/\s+/).slice(0, 2)
            .map(w => w[0].toUpperCase()).join('');
    }

    private notify(message: string, error = false): void {
        const cfg = new MatSnackBarConfig();
        cfg.duration = 4000;
        cfg.panelClass = error ? ['snack-error'] : ['snack-success'];
        this.snackBar.open(message, '✕', cfg);
    }
  public trackByIndex(i: number) { return i; }

}
